// extracted by mini-css-extract-plugin
module.exports = {"Search_Result_Container":"SearchDetail_Search_Result_Container__3siVS","Right_Section_Container":"SearchDetail_Right_Section_Container__3SF9b"};